"use client";

import { SurveyQuestionResponse } from "@yardzen/api-dtos";
import { UseFormRegister } from "react-hook-form";
import { TextResponseType } from "../QuizQuestionHandler";
import { Input } from "@yardzen/ui/components/input";

export function TextResponse({
  maxLength,
  placeholder,
  surveyQuestionResponse,
  register,
}: {
  maxLength: number;
  placeholder: string;
  surveyQuestionResponse?: SurveyQuestionResponse;
  register: UseFormRegister<any>;
}) {
  const response: TextResponseType | null = surveyQuestionResponse?.response
    ? (JSON.parse(surveyQuestionResponse.response) as TextResponseType)
    : null;

  return (
    <div className="flex w-full flex-row flex-wrap justify-center px-8">
      <Input
        type="text"
        {...register("response")}
        maxLength={maxLength}
        placeholder={placeholder}
        className="w-full rounded-md p-2"
        defaultValue={response?.answer || ""}
      />
    </div>
  );
}
